<template>
  <div class="pa-8 pa-md-16 text-md-center">
    {{ text || $t('COMMON.NO_DATA') }}
    <div class="d-flex align-center justify-center">
      <span
        class="empty-list-illustration"
        :style="{ width: typeof width === 'number' || /^\d+$/.test(width) ? `${width}px` : width }"
        aria-hidden="true"
        v-html="illustration"
      />
    </div>
  </div>
</template>

<script>
import emptyIllustration from '@/assets/images/empty.svg?raw'
import { themeSvgMarkup } from '@/utils/themeSvgUtils'

export default {
  name: 'EmptyListState',
  data: () => ({ illustration: themeSvgMarkup(emptyIllustration) }),
  props: {
    text: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 250
    }
  }
}
</script>

<style scoped>
.empty-list-illustration :deep(svg) {
  display: block;
  width: 100%;
  height: auto;
}
</style>
